import React from 'react'
import GetTeam from '/src/utils/GetTeam';
import WithLargeImagesTeamMember from './WithLargeImagesTeamMember'

const WithLargeImagesSelected = (team) => {

    return(
        <ul className="space-y-8 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-12 sm:space-y-0 lg:grid-cols-3 lg:gap-x-8">
            {GetTeam(Object.values(team)).map((item, index) => {
                return(
                    <WithLargeImagesTeamMember {...item} key={index}/>
                )
            })}
        </ul>
    )
};

export default WithLargeImagesSelected